import React from 'react';
import { emailHistories as emailHistoriesDuck, modals } from '../../ducks';
import { duckify, filterDuck, singleDuck } from '../../utils/duckify';
import { formatDate, formatTime } from 'utils';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import {users} from '../../ducks/index'

import withPagination from 'hocs/withPagination';
import withSorting from 'hocs/withSorting';
import ContactList from 'components/ContactList/ContactList';
import withFiltering from 'hocs/withFiltering';
import useBulkActions from 'hooks/useBulkActions';
import queryString from 'query-string';
import Pagination from 'react-ultimate-pagination-bootstrap-4';
import Filters from 'components/Filters/Filters';
import BulkActions from 'components/ContactList/BulkActions/BulkActions';
import BulkAction from 'components/ContactList/BulkActions/BulkAction';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import { Button } from 'react-bootstrap';
import './styles/EmailList.scss';
import DOMPurify from 'dompurify';
import LinkButton from 'components/LinkButton/LinkButton';
import InfoTooltip from 'components/shared/InfoTooltip';
import { bulkCheckboxColumn } from '../ContactList/ColumnDefinitions';


const filterFields = [{
  filter_type: 'TextFilter',
  solr_prompt: 'on_behalf_of_name',
  display_name: <React.Fragment>
    On Behalf Of Name <InfoTooltip nbsp>Search for emails sent "on behalf of" contacts whose name contains this text.</InfoTooltip>
  </React.Fragment>
},
  {
    filter_type: 'TextFilter',
    solr_prompt: 'receiver_email',
    display_name: <React.Fragment>
      Receiver Email <InfoTooltip nbsp>Search for emails sent to this email address (must be exact).</InfoTooltip>
    </React.Fragment>
  },
  {
    filter_type: 'TextFilter',
    solr_prompt: 'receiver_name',
    display_name: <React.Fragment>
      Receiver Name <InfoTooltip nbsp>Search for emails sent to contacts whose name contains this text.</InfoTooltip>
    </React.Fragment>
  },
  {
    filter_type: 'TextFilter',
    solr_prompt: 'subject',
    display_name: <React.Fragment>
      Subject <InfoTooltip nbsp>Search for emails whose subject contains this text.</InfoTooltip>
    </React.Fragment>
  }];

const ScheduledEmailsList = ({ emailHistories, onSort, sort, page, setPage, filters, setFilters, dispatch, currentUsers }) => {
  const { trackedItems,
    promptSelectAll,
    selectionMode,
    togglePageTracked,
    toggleTrackedItem,
    itemIsSelected,
    selectionModeCount} = useBulkActions(emailHistories);

  const totalPages = Math.ceil(emailHistories.total / emailHistories.perPage);

  const columns = [
    bulkCheckboxColumn({
      value: 'id',
      togglePageTracked,
      selectionMode,
      promptSelectAll,
      toggleTrackedItem,
      itemIsSelected
    }),
    {
      header: 'Scheduled At',
      sortName: 'scheduled_at',
      value: (history) => {
        const millisecondsTillSend = Date.parse(history.scheduled_at) - new Date();
        const clockColor = '#f7a006';
        return <td>
          {formatDate(history.scheduled_at)} at {formatTime(history.scheduled_at)}
          {millisecondsTillSend < 1000 * 60 * 30 &&
            <i className='fa fa-clock-o' style={{marginLeft: '1rem', color: clockColor}} title="Sending soon"/>}
        </td>;
      }
    },
    {
      header: 'Receiver Email',
      sortName: 'receiver_email',
      value: (history) => <td>{history.receiver_email}</td>
    },
    {
      header: 'Subject',
      sortName: 'subject',
      value: (history) => <td>{history.subject}</td>
    },
    {
      header: 'Receiver Name',
      sortName: 'receiver_name',
      value: (history) => <td>{history.receiver_name}</td>
    },
    {
      header: 'On behalf of',
      sortName: 'on_behalf_of_name',
      value: (history) => <td>{history.on_behalf_of_name}</td>
    },
    {header: "", value: (history) => <td>
        {<Button variant="link" className={"react-list-show-btn"} onClick={() => dispatch(modals.actions.show('MessageModal', {message: showEmail(history), title: "Scheduled Email Details"})) }>Show</Button>}|
        {<Button variant="link" className={"react-list-cancel-btn"} onClick={() => handleSingleDeletion(history)}>Cancel</Button>}</td>}
  ];


  // If we're in "select all" mode, this becomes all of the items left
  const currentSelection = () => (
    selectionMode === 'all' ?  emailHistories.map((history) => history.id ) : trackedItems
  )

  const handleBulkDeletion = () => {
    return (
      dispatch(modals.actions.show('VerificationModal', {
        message: <p>Are you sure you want to cancel these scheduled emails?</p>,
        onConfirm: () => dispatch(emailHistoriesDuck.actions.bulkRemove(currentSelection()))
          .then(() => dispatch(emailHistoriesDuck.actions.markDirty()))
          .catch(() => dispatch(modals.actions.show('UnexpectedError'))
        )
      })));
  };

  const handleSingleDeletion = (history) => {
    return (
      dispatch(modals.actions.show('VerificationModal', {
        message: <p>Are you sure you want to cancel this scheduled email?</p>,
        onConfirm: () => dispatch(emailHistoriesDuck.actions.remove(history))
          .then(() => dispatch(emailHistoriesDuck.actions.markDirty()))
          .catch(() => dispatch(modals.actions.show('UnexpectedError'))
          )
      })));
  };

  return (
    <div>
      <h2 className='inline'>
        Scheduled Emails
      </h2>

      {totalPages > 1 && (
        <div>
          <div className='react-pagination'>
            <div className='pagination pagination-right'>
              <Pagination
                currentPage={page}
                totalPages={totalPages}
                hideFirstAndLastPageLinks
                onChange={setPage}
              />
            </div>
          </div>
        </div>
      )}

      <Filters
        fields={filterFields}
        count={emailHistories.total}
        selected={filters}
        submitFilters={setFilters}
        selectCount={selectionModeCount()}
      />

      {currentUsers.communications_permitted &&
        <BulkActions>
          <BulkAction title="Edit" icon={faPencil} disabled={!emailHistories.ready || (trackedItems.length === 0 && selectionMode !== 'all')}>
            <BulkAction title="Cancel Scheduled Emails" icon={faBan} onClick={() => handleBulkDeletion()} />
          </BulkAction>
        </BulkActions>
        }

      <ContactList columns={columns}
                   contacts={emailHistories}
                   emptyMessage='There are no scheduled emails.'
                   onSort={onSort}
                   sort={sort}/>
    </div>
  );
};

const showEmail = (history) => {
  return (
    <div>
      <div className={'email-modal-field-group'}>
        <span className={'email-modal-label'}>Scheduled At</span>
        <span className={'email-modal-value'}>{formatDate(history.scheduled_at)} at {moment(history.scheduled_at).format('h:mm A')}</span>
      </div>
      <div className={'email-modal-field-group'}>
        <span className={'email-modal-label'}>To</span>
        <span className={'email-modal-value'}>{history.receiver_email}</span>
      </div>
      <div className={'email-modal-field-group'}>
        <span className={'email-modal-label'}>Receiver Name</span>
        <span className={'email-modal-value'}>{history.receiver_name}</span>
      </div>
      <div className={'email-modal-field-group'}>
        <span className={'email-modal-label'}>On Behalf Of</span>
        <span className={'email-modal-value'}>{history.on_behalf_of_name}</span>
      </div>
      <div className={'email-modal-field-group'}>
        <span className={'email-modal-label'}>Subject</span>
        <span className={'email-modal-value'}>{history.subject}</span>
      </div>

      <div className={'email-modal-field-group'}><span className={'email-modal-label'}>Message</span></div>
      <div className={'email-modal-body'} dangerouslySetInnerHTML={{ __html: history.body }}/>
    </div>
  );
};

const mapDucksToProps = ({ location, sortJson }) => {
  const query = queryString.parse(location.search);

  return {
    emailHistories: filterDuck(emailHistoriesDuck, {
      ...query,
      sort: sortJson,
      scheduled: true
    }),
    currentUsers: singleDuck(users, 'current')
  };
};

export default compose(
  withRouter,
  withFiltering,
  withPagination,
  withSorting({
    column: 'scheduled_at',
    order: 'desc'
  }),
  duckify(mapDucksToProps))(ScheduledEmailsList);
